import React, { useEffect, useState } from 'react';

import EditButton from '../../../elements/EditButton';
import Search from '../../../elements/Search';
import ViewButton from '../../../elements/ViewButton';
import Paginator from '../../../elements/paginator';
import axios from '../../../services/MyAxios';

import { CRM_PERMISSION } from '../Helpers/CrmPermissions';

import { CASINO_FREESPIN_CAMPAIGN_CREATE, CASINO_FREESPIN_CAMPAIGN_SHOW } from '../Helpers/CrmUrls';

import { replaceUrlParams } from '../Helpers/UrlHelper';

import ActionButton from 'crm/elements/ActionButton';

function FreespinCampaignsList() {
    const [campaigns, setCampaigns] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [filter, setFilter] = useState('');

    const getCampaigns = (page = 1) => {
        let url = '/crea/casino/api/freespin-campaigns';
        if (page !== 1) {
            url += `?page=${page}`;
        }
        axios.get(url, { params: { filter } }).then((response) => {
            setCampaigns(response.data.data);
            setCurrentPage(response.data.current_page);
            setLastPage(response.data.last_page);
        });
    };

    useEffect(() => {
        getCampaigns(currentPage);
    }, []);

    useEffect(() => {
        getCampaigns(currentPage);
    }, [filter]);

    const handleFilterTable = (value) => {
        setFilter(value);
    };

    return (
        <div className="card">
            <div className="card-body">
                <div className="d-flex justify-content-between">
                    <div>
                        <ActionButton
                            url={CASINO_FREESPIN_CAMPAIGN_CREATE}
                            title="Create new campaign"
                            permissions={[CRM_PERMISSION.CASINO_FREESPIN_CAMPAIGNS_CREATE]}
                        />
                    </div>
                    <Search additionalClasses="float-right" filterTable={handleFilterTable} />
                </div>
                {campaigns.length > 0 ? (
                    <div>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Name</th>
                                    <th>Game</th>
                                    <th>Game slug</th>
                                    <th>Actions</th>
                                    <th>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                {campaigns.map((campaign) => (
                                    <tr key={campaign.id}>
                                        <td>{campaign.id}</td>
                                        <td>{campaign.name}</td>
                                        <td>
                                            {campaign.casino_game.creator_name} | {campaign.casino_game.name}
                                        </td>
                                        <td>{campaign.casino_game.slug}</td>
                                        <td>
                                            <ViewButton
                                                url={replaceUrlParams(CASINO_FREESPIN_CAMPAIGN_SHOW, {
                                                    id: campaign.id,
                                                })}
                                                permissions={[CRM_PERMISSION.CASINO_FREESPIN_CAMPAIGNS_SHOW]}
                                                key="view"
                                                title="show"
                                            />
                                            <EditButton
                                                url={`/freespin-campaigns/${campaign.id}/edit`}
                                                permissions={[CRM_PERMISSION.CASINO_FREESPIN_CAMPAIGNS_EDIT]}
                                                key="edit"
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <Paginator currentPage={currentPage} lastPage={lastPage} onPageChange={getCampaigns} />
                    </div>
                ) : (
                    <p>Cannot find any campaign.</p>
                )}
            </div>
        </div>
    );
}

export default FreespinCampaignsList;
